import {
  Editor,
  Transforms,
  Node,
  Path,
  Range
} from 'slate';

import types from '../../elements/types';

import HelptapEditor from '../../helpers';

function listFactory(listType, listItemType) {

  return function withBulletedList(editor) {

    const { deleteBackward, insertBreak } = editor;

    editor.insertBreak = () => {
      const [match] = Editor.nodes(editor, {
        match(node) {
          return node.type === listItemType;
        },
        mode: 'lowest'
      });

      if (match) {
        const [node, nodePath] = match;
        if (Node.string(node) === '') {

          Editor.withoutNormalizing(editor, () => {
            const parentPath = Path.parent(nodePath);
            const listNode = Node.get(editor, parentPath);
            const isLastItem = nodePath[nodePath.length - 1] === listNode.children.length - 1;

            if (isLastItem) {
              // Case 3: Last item - delete and insert paragraph after list
              Transforms.removeNodes(editor, { at: nodePath });
              HelptapEditor.paragraph.insert(editor, Path.next(parentPath));

              if (listNode.children.length === 0) {
                Transforms.removeNodes(editor, { at: parentPath });
              }
            } else if (!isLastItem) {
              const newNode = HelptapEditor.list.buildListItemNode(listItemType);
              const newListItemPath = Path.next(nodePath);
              Transforms.insertNodes(editor, newNode, { at: newListItemPath });
              Transforms.select(editor, newListItemPath);
            }
          });
          return;
        }
      }

      insertBreak();
    };

    editor.deleteBackward = () => {

      const { selection } = editor;

      if (selection && Range.isCollapsed(selection)) {

        const [match] = Editor.nodes(editor, {
          match(node) {
            return node.type === listItemType;
          },
          mode: 'lowest'
        });

        if (match) {
          const [node, nodePath] = match;
          const containerPath = Path.parent(nodePath);
          const container = Node.get(editor, containerPath);
          if (Node.string(node) === '') {
            Editor.withoutNormalizing(editor, () => {
              if (container.children.length === 1) {
                // Exit list node to default block
                Transforms.setNodes(editor, HelptapEditor.paragraph.buildNode());
                Transforms.unwrapNodes(editor, { at: Path.parent(nodePath) });
              } else if (nodePath[nodePath.length - 1] === 0) {
                Transforms.removeNodes(editor, { at: nodePath });
                HelptapEditor.paragraph.insert(editor, containerPath);
                Transforms.select(editor, containerPath);
              } else if (nodePath[nodePath.length - 1] === container.children.length - 1) {
                Transforms.removeNodes(editor, { at: nodePath });
                const textNodePath = Path.next(containerPath);
                HelptapEditor.paragraph.insert(editor, textNodePath);
                Transforms.select(editor, textNodePath);
              } else {
                const textNodePath = Path.next(containerPath);
                const newContainer = HelptapEditor.list.buildEmptyListNode(listType);
                Transforms.insertNodes(editor, newContainer, { at: textNodePath });
                for (let index = container.children.length - 1; index > nodePath[nodePath.length - 1]; index--) {
                  const listItemPath = [...containerPath, index];
                  Transforms.moveNodes(editor, { at: listItemPath, to: [...textNodePath, 0] });
                }
                HelptapEditor.paragraph.insert(editor, textNodePath);
                Transforms.select(editor, textNodePath);
                Transforms.removeNodes(editor, { at: nodePath });
              }
            });
            return;
          }
        }

      }

      deleteBackward();
    };

    return editor;
  };

}

export const withBulletedList = listFactory(types.BULLETED_LIST, types.BULLETED_LIST_ITEM);
export const withNumberedList = listFactory(types.NUMBERED_LIST, types.NUMBERED_LIST_ITEM);